import Link from 'next/link';

const templateLinks = [
  { name: 'Templates', href: '/templates' },
  { name: 'Walmart', href: '/walmart-receipt' },
  { name: 'Target', href: '/target-receipt' },
  { name: "Lowe's", href: '/lowes-receipt' },
  { name: 'Starbucks', href: '/starbucks-receipt' },
  { name: 'StockX', href: '/stockx-receipt' },
];

const companyLinks = [
  { name: 'Documentation', href: 'https://docs.tryreceiptmaker.com' },
];

export default function Footer() {
  return (
    <div className="bg-white w-full pt-0" style={{ maxWidth: '100vw', boxSizing: 'border-box' }}>
      <footer
        className="mobile-padding footer-root"
        style={{ backgroundColor: '#EFEFEF', borderTopLeftRadius: '12px', borderTopRightRadius: '12px', paddingTop: '60px', paddingBottom: '60px', width: '100%', maxWidth: '100vw', boxSizing: 'border-box' }}
      >
        <div className="footer-content" style={{ maxWidth: '1440px', margin: '0 auto', display: 'grid', gridTemplateColumns: 'repeat(4, 1fr)', gap: '60px', width: '100%', boxSizing: 'border-box' }}>
          {/* Logo */}
          <div>
            <img alt="Receipt Maker" loading="lazy" decoding="async" style={{ height: '35px', width: 'auto', marginBottom: '20px' }} src="/logo-black.svg" />
            <p className="footer-body-text" style={{ marginTop: '16px' }}>
              Get started with <Link href="https://www.tryreceiptmaker.com/" className="footer-link-underline">Receipt Maker</Link> now!
            </p>
            <p className="footer-body-text" style={{ marginTop: '12px' }}>
              <a href="mailto:info@tryreceiptmaker.com" className="footer-link-plain">info@tryreceiptmaker.com</a>
            </p>
          </div>

          {/* Social */}
          <div>
            <h3 className="footer-heading">JOIN US ON SOCIAL MEDIA</h3>
            <div style={{ display: 'flex', gap: '12px', flexWrap: 'wrap' }}>
              <a href="https://www.youtube.com/@ReceiptMaker" target="_blank" rel="noopener noreferrer nofollow" aria-label="YouTube" className="footer-social-icon">
                <svg width="16" height="16" viewBox="0 0 24 24" fill="currentColor"><path d="M23.498 6.186a3.016 3.016 0 0 0-2.122-2.136C19.505 3.545 12 3.545 12 3.545s-7.505 0-9.377.505A3.017 3.017 0 0 0 .502 6.186C0 8.07 0 12 0 12s0 3.93.502 5.814a3.016 3.016 0 0 0 2.122 2.136c1.871.505 9.376.505 9.376.505s7.505 0 9.377-.505a3.015 3.015 0 0 0 2.122-2.136C24 15.93 24 12 24 12s0-3.93-.502-5.814zM9.545 15.568V8.432L15.818 12l-6.273 3.568z"/></svg>
              </a>
              <a href="https://www.pinterest.com/receiptmaker/" target="_blank" rel="noopener noreferrer nofollow" aria-label="Pinterest" className="footer-social-icon">
                <svg width="16" height="16" viewBox="0 0 24 24" fill="currentColor"><path d="M12 0C5.373 0 0 5.373 0 12c0 5.084 3.163 9.426 7.627 11.174-.105-.949-.2-2.405.042-3.441.218-.937 1.407-5.965 1.407-5.965s-.359-.719-.359-1.782c0-1.668.967-2.914 2.171-2.914 1.023 0 1.518.769 1.518 1.69 0 1.029-.655 2.568-.994 3.995-.283 1.194.599 2.169 1.777 2.169 2.133 0 3.772-2.249 3.772-5.495 0-2.873-2.064-4.882-5.012-4.882-3.414 0-5.418 2.561-5.418 5.207 0 1.031.397 2.138.893 2.738.098.119.112.224.083.345l-.333 1.36c-.053.22-.174.267-.402.161-1.499-.698-2.436-2.889-2.436-4.649 0-3.785 2.75-7.262 7.929-7.262 4.163 0 7.398 2.967 7.398 6.931 0 4.136-2.607 7.464-6.227 7.464-1.214 0-2.359-.632-2.75-1.378l-.748 2.853c-.271 1.043-1.002 2.35-1.492 3.146C9.57 23.812 10.763 24 12 24c6.627 0 12-5.373 12-12S18.627 0 12 0z"/></svg>
              </a>
              <a href="https://www.instagram.com/tryreceiptmaker/" target="_blank" rel="noopener noreferrer nofollow" aria-label="Instagram" className="footer-social-icon">
                <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><rect x="2" y="2" width="20" height="20" rx="5" ry="5"/><path d="M16 11.37A4 4 0 1 1 12.63 8 4 4 0 0 1 16 11.37z"/><line x1="17.5" y1="6.5" x2="17.51" y2="6.5"/></svg>
              </a>
            </div>
          </div>

          {/* Templates */}
          <div>
            <h3 className="footer-heading">TEMPLATES</h3>
            <ul className="footer-link-list">
              {templateLinks.map((item) => (
                <li key={item.name}><Link href={item.href} className="footer-link">{item.name}</Link></li>
              ))}
            </ul>
          </div>

          {/* Company */}
          <div>
            <h3 className="footer-heading">OUR COMPANY</h3>
            <ul className="footer-link-list">
              {companyLinks.map((item) => (
                <li key={item.name}><Link href={item.href} className="footer-link">{item.name}</Link></li>
              ))}
            </ul>
          </div>
        </div>
      </footer>
    </div>
  );
}
